import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export const CartDetail = () => {
  const [addcart, setaddcart] = useState(false);

  return (
    <div className="h-screen clearfix pb-10 bg-gray-50">
      <div className="bg-white w-full">
        <div className="container mx-auto xl:px-14 px-4 py-4 flex flex-wrap xl:justify-between justify-around">
          <div><Link to="/"><img src="images/logo.png" alt="Sightcart" className="w-44" /></Link></div>
          <div className="text-cyan-500 font-light text-xl xl:mt-0 mt-2"><i className="fa fa-shield mr-3"></i> 100% safe and secure</div>
        </div>
      </div>
      <div className="container mx-auto px-8 xl:flex flex-row gap-10 mt-6">
        <div className="xl:w-4/6 w-full">
          <h2 className="text-xl font-light">Cart (3 items)</h2>
          <div className="mt-4 bg-white rounded-md shadow-md p-7">
            <div className="xl:flex md:flex flex-row gap-8 items-center">
              <div className="xl:w-4/12 md:w-4/12 w-full"><Link to=""><img src="images/product-01.png" alt="Product" /></Link></div>
              <div className="xl:w-4/6 md:w-4/6 w-full space-y-2 xl:mt-0 mt-2">
                <div className="flex gap-8 justify-between">
                  <h2><Link to="">Grey Green Grey Full Rim Rectangle Lenskart Air Air Wrap La E14259-C2 Eyeglasses</Link></h2>
                  <div>$148</div>
                </div>
                <div className="flex gap-8 font-light text-sm text-gray-600 justify-between">
                  <h3>Best-Seller: Thin Lens With Blu-Ray Block & All Coatings_sg With Upgrade To 1.74 Index Sg <br /> <span className="block my-4">You Can Upload Prescription After Payment</span></h3>
                  <div className="font-normal text-base">$200</div>
                </div>
                <hr className="border-dashed" />
                <div className="flex gap-4 mt-6">
                  <button className="underline hover:no-underline">Remove</button> | <button className="underline hover:no-underline">Duplicate</button>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-10 bg-white rounded-md shadow-md p-7">
            <div className="xl:flex md:flex flex-row gap-8 items-center">
              <div className="xl:w-4/12 md:w-4/12 w-full"><Link to=""><img src="images/lens-1.jpeg" alt="Product" /></Link></div>
              <div className="xl:w-4/6 md:w-4/6 w-full space-y-2 xl:mt-0 mt-2">
                <div className="flex gap-8 justify-between">
                  <h2><Link to="">Aqualens Daily Disposable Contact Lenses (10 Lenses/Box) (Quantity: 2)</Link></h2>
                  <div>$10</div>
                </div>
                <div className="flex gap-8 font-light text-sm text-gray-600 justify-between">
                  <h3><span className="font-normal text-gray-900">Usage:</span> Daily Disposable</h3>
                </div>
                <div className="">
                  <div className="border rounded">
                    <h4 className="bg-gray-100 text-sm p-2">Your Power</h4>
                    <div className="">
                      <table class="table-auto border-spacing-2 text-left w-full text-sm font-light">
                        <thead>
                          <tr>
                            <td></td>
                            <td className="p-2 font-normal">Spherical (SPH)</td>
                            <td className="p-2 font-normal">Boxes</td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="p-2 font-normal">LEFT</td>
                            <td className="p-2">-0.50</td>
                            <td className="p-2">1</td>
                          </tr>
                          <tr>
                            <td className="p-2 font-normal">RIGHT</td>
                            <td className="p-2">-2.00</td>
                            <td className="p-2">1</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <hr className="border-dashed" />
                <div className="flex gap-4 mt-6">
                  <button className="underline hover:no-underline">Remove</button>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div className="xl:w-4/12 w-full mt-10 xl:mt-0">
          <h2 className="text-xl font-light">Bill Details</h2>
          <div className="mt-4 bg-white rounded-md shadow-md p-7 space-y-3 font-light">
            <div className="flex justify-between">
              <div>Total VIP Price</div>
              <div>$368</div>
            </div>
            <hr className="border-dashed" />
            <div className="flex justify-between">
              <div>Convenience Fees</div>
              <div className="text-cyan-500">Free</div>
            </div>
            <hr className="border-dashed" />
            <div className="flex justify-between font-normal text-xl">
              <div>Total payable</div>
              <div>$368</div>
            </div>
          </div>

          <div className="border border-yellow-500 rounded-md shadow-md bg-cyan-50 my-6 p-5 shine-animation">
            SHOPPING SEASON
            <p className="text-sm font-light">Extra 25% Off. Use coupon: S25</p>
          </div>

          <Link to="" className="rounded-md shadow-md bg-white p-5 shine-animation flex justify-between items-center" onClick={() => setaddcart((prevState) => !prevState)}>
            <div>
              Apply Coupon
              <p className="text-sm font-light">Check available offers</p>
            </div>
            <div className="border rounded-full px-3 inline-block h-fit"><i class="fa fa-angle-right"></i></div>
          </Link>

          <button className="bg-cyan-500 text-white w-full mt-6 rounded-md uppercase p-4 tracking-wider font-light">Proceed To Checkout</button>

        </div>
      </div>

      {/* Coupon Slide */}
      <div className={addcart === true ? "fixed add_to_cart right-0 bg-white lg:w-1/3 w-full z-[9999] top-0 h-screen px-5 py-7 overflow-y-auto shadow-xl" : "fixed add_to_cart -right-full lg:w-1/3 w-full z-[9999] top-0 h-screen p-5 overflow-y-auto"}>
        <span className="absolute right-2 font-bold cursor-pointer top-1 text-xl text-gray-500 hover:text-gray-700" onClick={() => setaddcart((prevState) => !prevState)}>x</span>
        <div className="mt-4">
          <h2 className="text-xl mb-4">Apply Coupon</h2>
          <div class="flex mt-6">
            <div class="relative w-[70%] ">
              <input name="email" type="email" class="w-full p-1 py-3 px-4 placeholder-transparent border border-gray-200 rounded-l peer focus:outline-none focus:border-gray-500 focus:shadow-sm text-gray-700" placeholder="Apply Coupon Code" autocomplete="off" />
              <label for="email" class="absolute top-0 left-0 h-full px-4 py-3 text-sm transition-all duration-100 ease-in-out origin-left transform scale-75 translate-x-1 -translate-y-3 opacity-75 pointer-events-none peer-placeholder-shown:opacity-100 peer-focus:opacity-75 peer-placeholder-shown:scale-100 peer-focus:scale-75 peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-3 peer-placeholder-shown:translate-x-0 peer-focus:translate-x-1 text-gray-500">Apply Coupon Code</label>
            </div>
            <div class="w-[30%]">
              <button class="uppercase bg-cyan-500 text-white py-[13px] px-5 rounded-r font-light tracking-widest">Apply</button>
            </div>
          </div>
          <h3 className="text-xl mt-4 font-light">Sorry! No Coupons Available at the moment.</h3>
        </div>
      </div>

    </div>
  )
}